import { css, type ExecutionContext } from 'styled-components'
import { themeGet } from '@styled-system/theme-get'

type CustomWeightProps = {
  bold?: boolean
  bolder?: boolean
  medium?: boolean
  regular?: boolean
}

const regularCss = ({ regular }: ExecutionContext & { regular?: boolean }) =>
  regular &&
  css`
    font-weight: ${themeGet('fontWeights.0')};
  `

const mediumCss = ({ medium }: ExecutionContext & { medium?: boolean }) =>
  medium &&
  css`
    font-weight: ${themeGet('fontWeights.1')};
  `

const boldCss = ({ bold }: ExecutionContext & { bold?: boolean }) =>
  bold &&
  css`
    font-weight: ${themeGet('fontWeights.2')};
  `

export type { CustomWeightProps }
export { boldCss, mediumCss, regularCss }
